export class InventoryCountStatusDto {
  inventoryCountStatusName: string;
  inventoryCountStatusGorup: string;
  description: string;
  statusOrder: string;
}
